import {
  LayoutDashboard, ClipboardCheck, TrendingUp, BrainCircuit,
  BarChart3, FileText, Users, Shield, Settings, Calendar
} from "lucide-react";

export const CURRENT_YEAR = new Date().getFullYear();

export const CURRENT_WBR_WEEK = (() => {
  const now = new Date();
  const start = new Date(now.getFullYear(), 0, 1);
  const days = Math.floor((now - start) / 86400000);
  return Math.ceil((days + start.getDay() + 1) / 7) - 1;
})();

export const ICON_OPTIONS = [
  "LayoutDashboard", "ClipboardCheck", "TrendingUp", "BrainCircuit",
  "BarChart3", "FileText", "Users", "Shield", "Settings", "Calendar"
];

export const TYPE_OPTIONS = [
  "coverpage", "actiontracker", "businessupdates", "pulseai", "report", "allinone"
];

export const ICON_MAP = {
  LayoutDashboard, ClipboardCheck, TrendingUp, BrainCircuit,
  BarChart3, FileText, Users, Shield, Settings, Calendar
};

// Helper
export function getAllSidebarItems(functionSidebar) {
  if (!functionSidebar) return [];
  const items = [];
  for (const section of Object.values(functionSidebar)) {
    for (const item of section.items || []) {
      items.push({ key: item.key, label: item.label, type: item.type });
    }
  }
  return items;
}
